import { deepParseJson } from "../utils/index.ts";

/**
 * Token leído en el mismo tick del login.
 * redux-persist escribe localStorage después del dispatch; Home no debe
 * disparar requests sin Authorization por esa carrera.
 */
let memoryToken = "";

export function rememberSessionToken(token: string | null | undefined): void {
  memoryToken = typeof token === "string" ? token : "";
}

export function readSessionToken(): string {
  if (memoryToken) {
    return memoryToken;
  }

  try {
    const raw = localStorage.getItem("persist:root");
    const persistData = deepParseJson(raw);
    const token = persistData?.auth?.token;
    return typeof token === "string" ? token : "";
  } catch {
    return "";
  }
}
